import api from './api';

const BASE_URL = '/user-client-assignments';

const userClientAssignmentService = {
  /**
   * Obtener todas las asignaciones (solo admin)
   */
  getAll: async () => {
    const response = await api.get(BASE_URL);
    return response.data.data;
  },

  /**
   * Obtener matriz de asignaciones usuario-cliente
   */
  getMatrix: async () => {
    const response = await api.get(`${BASE_URL}/matrix`);
    return response.data.data;
  },

  /**
   * Obtener resumen de asignaciones
   */
  getSummary: async () => {
    const response = await api.get(`${BASE_URL}/summary`);
    return response.data.data;
  },

  /**
   * Obtener asignaciones de un usuario específico
   */
  getByUserId: async (userId) => {
    const response = await api.get(`${BASE_URL}/user/${userId}`);
    return response.data.data;
  },

  /**
   * Obtener clientes asignados a un usuario
   */
  getAssignedClients: async (userId) => {
    const response = await api.get(`${BASE_URL}/user/${userId}/clients`);
    return response.data.data;
  },

  /**
   * Obtener IDs de clientes asignados a un usuario
   */
  getAssignedClientIds: async (userId) => {
    const response = await api.get(`${BASE_URL}/user/${userId}/client-ids`);
    return response.data.data;
  },

  /**
   * Obtener usuarios asignados a un cliente
   */
  getByClientId: async (clientId) => {
    const response = await api.get(`${BASE_URL}/client/${clientId}`);
    return response.data.data;
  },

  /**
   * Verificar si un usuario tiene acceso a un cliente
   */
  checkAccess: async (userId, clientId) => {
    const response = await api.get(`${BASE_URL}/check/${userId}/${clientId}`);
    return response.data.data.hasAccess;
  },

  /**
   * Crear una asignación
   */
  create: async (userId, clientId, notes = null) => {
    const response = await api.post(BASE_URL, { userId, clientId, notes });
    return response.data.data;
  },

  /**
   * Asignar múltiples clientes a un usuario
   */
  bulkAssign: async (userId, clientIds, notes = null) => {
    const response = await api.post(`${BASE_URL}/bulk`, { userId, clientIds, notes });
    return response.data.data;
  },

  /**
   * Sincronizar asignaciones de un usuario (reemplazar todas)
   */
  syncAssignments: async (userId, clientIds) => {
    const response = await api.put(`${BASE_URL}/sync/${userId}`, { clientIds });
    return response.data.data;
  },

  /**
   * Actualizar una asignación
   */
  update: async (id, data) => {
    const response = await api.put(`${BASE_URL}/${id}`, data);
    return response.data.data;
  },

  /**
   * Eliminar una asignación
   */
  delete: async (id) => {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * Eliminar asignación por usuario y cliente
   */
  deleteByUserAndClient: async (userId, clientId) => {
    const response = await api.delete(`${BASE_URL}/user/${userId}/client/${clientId}`);
    return response.data;
  },

  /**
   * Obtener mis clientes asignados (usuario actual)
   */
  getMyClients: async () => {
    const response = await api.get(`${BASE_URL}/my-clients`);
    return response.data.data;
  },
};

export default userClientAssignmentService;
